<template>
  <div v-if="showUploader" class="uploader">
    <div class="uploader__tab" @click="showList = !showList">
      <span>Upload process</span>
      <div class="uploader__tab__actions">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="21"
          height="21"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#fff"
          stroke-width="2.5"
          stroke-linecap="round"
          stroke-linejoin="round"
          :class="{ arrow_side: !showList }"
        >
          <polyline points="6 9 12 15 18 9"></polyline>
        </svg>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="#fff"
          stroke="#fff"
          stroke-width="3.2"
          stroke-linecap="round"
          stroke-linejoin="round"
          @click.prevent.stop="closePopup"
        >
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </div>
    </div>
    <div v-if="showList" class="uploader__list" :key="uploadCount">
      <div
        v-for="(item, index) in uploadList"
        :key="index"
        class="uploader__list__item"
      >
        <div class="flex flex-row gap-2.5 items-center overflow-hidden">
          <div class="svg-wrapper">
            <img
              v-if="item.loading"
              :src="
                theme
                  ? require('@/assets/images/app-item-uploading-dark.svg')
                  : require('@/assets/images/app-item-uploading.svg')
              "
              alt="app-item uploading"
              class="max-w-[16px] h-4 w-4"
            />
            <img
              v-else-if="item.success"
              :src="
                theme
                  ? require('@/assets/images/app-item-uploaded-dark.svg')
                  : require('@/assets/images/app-item-uploaded.svg')
              "
              alt="app-item uploading"
              class="max-w-[16px] !h-4 !w-4"
            />
            <img
              v-else
              :src="
                theme
                  ? require('@/assets/images/app-item-error-dark.svg')
                  : require('@/assets/images/app-item-error.svg')
              "
              alt="app-item uploading"
              class="max-w-[16px] !h-4 !w-4"
            />
          </div>
          <span
            class="text-[11px] font-medium overflow-ellipsis overflow-hidden whitespace-nowrap dark:text-greyscale-400"
            >{{ item.title }}</span
          >
        </div>
        <div v-if="item.loading">
          <CircularProgressBar
            :percentage="uploadPercentage"
            @close="cancelUpload"
          >
            <p class="text-[10px] font-medium text-primary-400">
              {{ uploadPercentage }}
            </p>
          </CircularProgressBar>
        </div>
        <div v-else-if="item.success">
          <CircularProgressBar :isFinished="true">
            <p class="text-[10px] font-medium text-primary-400">{{ "100%" }}</p>
          </CircularProgressBar>
        </div>
        <div v-else class="flex flex-row gap-1">
          <Button
            @click="retryUpload(index)"
            class="bg-[#F7FAFC] dark:bg-transparent ball h-7 w-7 p-0 flex items-center justify-center"
          >
            <img
              v-if="theme"
              src="@/assets/images/refresh-dark.svg"
              alt="refresh"
            />
            <svg
              v-else
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="17"
              viewBox="0 0 16 17"
              fill="none"
            >
              <path
                d="M9.92676 4.37334C9.34676 4.2 8.70676 4.08667 8.00009 4.08667C4.80676 4.08667 2.22009 6.67334 2.22009 9.86667C2.22009 13.0667 4.80676 15.6533 8.00009 15.6533C11.1934 15.6533 13.7801 13.0667 13.7801 9.87334C13.7801 8.68667 13.4201 7.58 12.8068 6.66"
                stroke="#1A202C"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M10.7533 4.53316L8.82666 2.31982"
                stroke="#FF4747"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M10.7534 4.5332L8.50671 6.1732"
                stroke="#FF4747"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </Button>
          <Button
            @click="removeItem(index)"
            class="bg-[#F7FAFC] dark:bg-[#482D41] ball h-7 w-7 p-0 flex items-center justify-center"
          >
            <img
              v-if="theme"
              src="@/assets/images/trash-dark.svg"
              alt="trash"
            />
            <svg
              v-else
              xmlns="http://www.w3.org/2000/svg"
              width="17"
              height="17"
              viewBox="0 0 17 17"
              fill="none"
            >
              <path
                d="M14.6145 4.75781C12.4292 4.54125 10.2308 4.42969 8.03888 4.42969C6.7395 4.42969 5.44013 4.49531 4.14075 4.62656L2.802 4.75781"
                stroke="#21242B"
                stroke-width="1.3125"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M6.41138 4.09481L6.55575 3.23513C6.66075 2.61169 6.7395 2.14575 7.84856 2.14575H9.56794C10.677 2.14575 10.7623 2.63794 10.8608 3.24169L11.0051 4.09481"
                stroke="#21242B"
                stroke-width="1.3125"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M13.2035 6.8313L12.777 13.4397C12.7048 14.47 12.6457 15.2707 10.8148 15.2707H6.60164C4.7707 15.2707 4.71164 14.47 4.63945 13.4397L4.21289 6.8313"
                stroke="#21242B"
                stroke-width="1.3125"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M7.6123 11.6614H9.79762"
                stroke="#FF4747"
                stroke-width="1.3125"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M7.06763 9.03638H10.3489"
                stroke="#FF4747"
                stroke-width="1.3125"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </Button>
        </div>
      </div>
    </div>
    <div
      v-else-if="loading"
      class="px-4 py-1 text-xs font-bold text-secondary-400"
    >
      Uploading 1 Item ..
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import CircularProgressBar from "@/components/CircularProgressBar";
import Button from "@/components/Button";

export default {
  name: "UploadFilePopup",
  components: { Button, CircularProgressBar },
  data() {
    return {
      uploadList: [],
      showList: true,
      uploadPercentage: "0%",
      loading: false,
      uploadCount: 0,
    };
  },
  created() {
    this.theme = this.getTheme === "dark";
  },
  methods: {
    ...mapActions([
      "addApplication",
      "abortAppUpload",
      "emitUploadApp",
      "emitMixPanelEvent",
      "getApplications",
      "emitConfirmData",
      "emitNotification",
    ]),
    upload(app) {
      this.emitMixPanelEvent({
        event: "LibraryUploadFile",
        data: {
          click: true,
        },
      });
      let current = app;
      current.loading = true;
      this.loading = true;
      current.success = null;
      this.uploadPercentage = "0%";
      let index = this.uploadList.push(current) - 1;

      this.addApplication(app)
        .then(() => {
          this.uploadList[index].success = true;
          this.uploadList[index].loading = false;
          this.emitUploadApp(null);
          this.emitNotification({
            type: "success",
            text: this.$t("notification.app.success_upload"),
          });
          this.getAllAps();
        })
        .catch((e) => {
          if (this.uploadList.length) {
            this.uploadList[index].success = false;
            this.uploadList[index].loading = false;
          }
          this.emitUploadApp(null);
          const errText =
            e === "canceled" ? this.$t("notification.app.canceled") : e;
          this.emitNotification({
            type: "error",
            text: errText,
          });
          this.getAllAps();
        })
        .finally(() => {
          this.loading = false;
          this.uploadCount = this.uploadCount + 1;
        });
    },
    getAllAps() {
      this.getApplications().then((apps) => {
        this.emitMixPanelEvent({
          event: "LibraryAppCount",
          data: {
            LibraryAppCount: apps.length,
          },
        });
      });
    },
    resetPopupData() {
      this.loading = false;
      this.uploadList = [];
      this.showList = true;
    },
    closePopup() {
      if (this.loading) {
        this.emitConfirmData({
          header: this.$t("confirm.cancel_uploads.header"),
          text: this.$t("confirm.cancel_uploads.text"),
          actions: {
            confirm: this.$t("button.popup.cancel_uploads.confirm"),
            cancel: this.$t("button.popup.cancel_uploads.cancel"),
          },
          callback: (isConfirm) => {
            if (!isConfirm && this.loading) {
              this.cancelUpload();
              this.resetPopupData();
            }
          },
        });
      } else {
        this.resetPopupData();
      }
    },
    cancelUpload() {
      this.abortAppUpload();
    },
    removeItem(index) {
      this.uploadList.splice(index, 1);
    },
    retryUpload(index) {
      if (!this.loading) {
        const file = {
          title: this.uploadList[index].title,
          file: this.uploadList[index].file,
          isResignable: this.uploadList[index].isResignable,
        };
        this.removeItem(index);
        this.upload(file);
      }
    },
  },
  computed: {
    ...mapGetters(["getUploadApp", "loadingState", "getTheme"]),
    showUploader() {
      return this.uploadList.length > 0;
    },
  },
  watch: {
    getUploadApp(value) {
      if (value !== null && !this.loading) {
        this.upload(value);
      }
    },
    loadingState: {
      handler(val) {
        this.uploadPercentage = `${parseInt(
          (100 * val.loaded) / val.total,
          0
        )}%`;
      },
    },
  },
};
</script>

<style>
@import "index.module.css";
</style>
